// Sugalarm — provider catalog used by the login flow. Glyphs ported
// from login.jsx.

export type ProviderId = "dexcom" | "libre";

export interface Provider {
  id: ProviderId;
  name: string;
  models: string;
  blurb: string;
  color: string;
  defaultRegion: "US" | "OUS";
  glyph: (size?: number) => JSX.Element;
}

export const PROVIDERS: Provider[] = [
  {
    id: "dexcom",
    name: "Dexcom",
    models: "G7 · G6",
    blurb: "Real-time, calibration-free CGM with 5-min readings.",
    color: "#0066B3",
    defaultRegion: "US",
    glyph: (size = 36) => (
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none">
        <circle cx="20" cy="20" r="17" stroke="#0066B3" strokeWidth="2.5" />
        <circle cx="20" cy="20" r="9" stroke="#0066B3" strokeWidth="2.5" />
        <circle cx="20" cy="20" r="3.5" fill="#0066B3" />
      </svg>
    ),
  },
  {
    id: "libre",
    name: "FreeStyle Libre",
    models: "Libre 2 · Libre 3",
    blurb: "Abbott CGM, paired via LibreLinkUp share.",
    color: "#FFC72C",
    defaultRegion: "US",
    glyph: (size = 36) => (
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none">
        <rect x="6" y="6" width="28" height="28" rx="14" stroke="#FFC72C" strokeWidth="2.5" />
        <path
          d="M14 24 L18 16 L22 22 L26 14"
          stroke="#FFC72C"
          strokeWidth="2.5"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

export function findProvider(id: ProviderId): Provider {
  return PROVIDERS.find((p) => p.id === id) ?? PROVIDERS[0]!;
}
